import i18next from 'i18next';

import { CATEGORY_TYPES_OBJECT } from '@commons/constants/categoryTypes';

import { allergen as allergenService } from '@services/allergen';
import clientService from '@services/client';

/**********************/
/* Fetch Data Methods */
/**********************/

/**
 * Render the allergens form section with the different inputs that should be displayed
 *
 * @param {Function} setAllergens  - Method used to set the local state of the allergens variable
 */
export async function fetchAllergensList(setAllergens) {
  const result = await allergenService.getAllergens();

  const formattedResult = result.map((allergen) => ({
    ...allergen,
    name: i18next.t(`ADMIN.INGREDIENTS.${allergen.translationKey}`),
  }));

  setAllergens(formattedResult);
}

/**
 * Fetch the client's ingredient categories, naming the unnamed one "None" and sorting them by name
 *
 * @param {Function} setIngredientsCategories  - Method used to set the local state of the categories variable
 */
export async function fetchIngredientCategories(setIngredientsCategories) {
  const { categories } = await clientService.getCategoriesAndSubCategories(
    CATEGORY_TYPES_OBJECT.INGREDIENT,
  );

  const formattedCategories = categories.map((category) => ({
    ...category,
    name: category.name || i18next.t('GENERAL.NONE_VALUE'),
  }));

  setIngredientsCategories(
    formattedCategories.sort((categoryA, categoryB) =>
      categoryA.name.localeCompare(categoryB.name),
    ),
  );
}

export default {
  fetchAllergensList,
  fetchIngredientCategories,
};
